import { ProductQueueSearchCriteria } from '../reservation-v2/criteria/product-queue-search-criteria';

export class SavedCriteriaV2 {
    criteriaId: number;
    criteriaName: string;
    criteria: any;
    userId: number;
}
